import { graphql } from 'gatsby'
import React from 'react'

import Form from '@/components/form/form'
import Image from '@/components/image/image'
import {
  type Download,
  formDownloads,
  formSubscription
} from '@/internal/types/form'

const FormBlock: React.FC<
  Queries.FormBlockFragment | Queries.FormInlineFragment
> = ({ formtype, gateContent, title, subtitle, image }) => {
  const form = formtype as formDownloads | formSubscription
  const gatsbyImageData =
    image?.gatsbyImageData ?? gateContent?.[0]?.cover?.gatsbyImageData ?? null

  if (!form) return <></>
  if (form !== 'bulletin' && gateContent !== null && gateContent?.length === 0)
    return <></>

  const papers = gateContent?.reduce((acc: Download[], item) => {
    if (!item) return acc
    const { originalId, externalName } = item
    if (originalId && externalName) {
      const paper = {
        originalId,
        externalName
      } as Download
      acc.push(paper)
    }
    return acc
  }, [])

  return (
    <div className="container">
      <div className="row">
        {gatsbyImageData != null && (
          <div className="col-lg-5 col-12 d-none d-lg-block mx-auto">
            <Image image={gatsbyImageData} />
          </div>
        )}
        <div className="col-lg-6 col-md-12 col-12 mx-auto my-5">
          <Form
            title={title ?? ''}
            subtitle={subtitle ?? ''}
            contentSelected={papers?.map((paper) => paper.originalId)}
            values={{
              form,
              downloads: papers
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default FormBlock

export const query = graphql`
  fragment FormInline on DatoCmsForm {
    __typename
    id: originalId
    title
    subtitle
    formtype
    image {
      gatsbyImageData(width: 600, layout: FULL_WIDTH)
    }
    gateContent {
      ... on DatoCmsPctPaper {
        originalId
        externalName
        cover {
          alt
          gatsbyImageData(width: 600, layout: FULL_WIDTH)
        }
      }
    }
  }
  fragment FormBlock on DatoCmsForm {
    id
    __typename
    navigationLabel
    originalId
    subtitle
    title
    formtype
    image {
      gatsbyImageData(width: 600, layout: FULL_WIDTH)
    }
    gateContent {
      ... on DatoCmsPctPaper {
        originalId
        externalName
        cover {
          alt
          gatsbyImageData(width: 600, layout: FULL_WIDTH)
        }
      }
    }
  }
`
